import { graphql } from 'react-relay/legacy';

export const shopRoot = graphql`
    query shopRootQuery($urlLabel: String!, $previewId: String) {
        viewer {
            landingPage(urlLabel: $urlLabel, previewId: $previewId) {
                title
                seoTitle
                seoDescription
                translationStatus
                ...ShopWrapper_landingPage
            }
        }
    }
`;
